import { render, staticRenderFns } from "./DataScopeSelect.vue?vue&type=template&id=421f2c66&scoped=true"
import script from "./DataScopeSelect.vue?vue&type=script&lang=js"
export * from "./DataScopeSelect.vue?vue&type=script&lang=js"
import style0 from "./DataScopeSelect.vue?vue&type=style&index=0&id=421f2c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f2c66",
  null
  
)

export default component.exports